import { __decorate } from "tslib";
import { Vue, Component, Mixins } from 'vue-property-decorator';
import ButtonApp from '@/components/ButtonApp.vue';
import { uiMapper } from '@/services/store/modules/ui/store';
import { dataMapper } from '@/services/store/modules/data/store';
import Inputmask from 'inputmask';
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(['formCallIsShown', 'breakpoint'])
    },
    methods: {
        ...uiMapper.mapMutations(['closeFormCall', 'openFormCall'])
    }
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(['formCall']),
        ...dataMapper.mapGetters(['formName', 'formPhone', 'formMail', 'quizIsFilled'])
    },
    methods: {
        ...dataMapper.mapMutations(['clearForm', 'setFormCallTitle', 'setFormCallScreen']),
        ...dataMapper.mapActions(['sendForm', 'updateFormField'])
    }
});
let FormQuiz = class FormQuiz extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.activeStepIndex = 0;
        this.im = null;
        this.formType = 'quiz';
    }
    get formCallName() { return this.formName(this.formType); }
    get formCallPhone() { return this.formPhone(this.formType); }
    get formCallMail() { return this.formMail(this.formType); }
    get name() { return this.formName(this.formType).value; }
    set name(value) { this.updateFormField({ formType: this.formType, name: 'name', 'value': value }); }
    get phone() { return this.formPhone(this.formType).value; }
    set phone(value) { this.updateFormField({ formType: this.formType, name: 'phone', 'value': value }); }
    get mail() { return this.formMail(this.formType).value; }
    set mail(value) { this.updateFormField({ formType: this.formType, name: 'mail', 'value': value }); }
    get isGtLg() { return this.breakpoint === 'lg' || this.breakpoint === 'xl'; }
    get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm'; }
    async mounted() {
        this.clearForm(this.formType);
        await this.$nextTick();
        this.setFormCallTitle('Квиз-форма');
        this.setFormCallScreen('Модальное окно \'Квиз\'');
        this.initPhoneMask();
    }
    initPhoneMask() {
        const selector = document.getElementById('quizPhoneInput-jda323-js');
        if (!selector)
            return;
        this.im = new Inputmask('+7(999)999-9999');
        this.im.mask(selector);
    }
    confirmForm() {
        this.sendForm(this.formType)
            .then(() => {
            this.closeFormCall();
            this.$emit('quizFinished');
            // @ts-ignore
            this.$router.push({ path: '/submit' }).catch(() => { });
        });
    }
    isInvalid(field) {
        return this.formCall.validationIsShown && field.validationRequired && !field.isValid;
    }
};
FormQuiz = __decorate([
    Component({
        components: {
            ButtonApp
        },
    })
], FormQuiz);
export default FormQuiz;
